<template>
    <div class="content">
        <div class="loginBox">
            <!-- <div class="header"> -->
            <!-- <div class="logoBox" :style="note">
                </div> -->
            <!-- <h3 class="mainTitle">GPS绑定</h3> -->
            <!-- </div> -->
            <div class="body">
                <div class="imeiInputs">
                    <!-- <label class="title" :style="[focus2 ? titleStyle:'']">车牌号</label> -->
                    <!-- <input type="text" class="input" v-model="filter.truck_no" @focus="getFocus(1)" @blur="getBlur(1)" @keyup.enter="submitForm()"> -->
                    <div class="keyboard-item">
                        车牌号
                    </div>
                    <div class="keyboard">
                        <div class="numberCover">
                            <div class="input-box"
                                @click="clickShowKeyboard">
                                <li>{{ first }}</li>
                                <li>{{ numArr[0] }}</li>
                                <li>{{ numArr[1] }}</li>
                                <li>{{ numArr[2] }}</li>
                                <li>{{ numArr[3] }}</li>
                                <li>{{ numArr[4] }}</li>
                                <li>{{ numArr[5] }}</li>
                                <li v-show="newNumberFlag">{{ numArr[6] }}</li>
                            </div>
                            <div class="button">
                                <van-button type="primary" class="bottom-button" @click="changeNumber"
                                    v-show="!newNumberFlag">
                                    普
                                </van-button>
                                <van-button type="primary" class="bottom-button" @click="changeNumber"
                                    v-show="newNumberFlag">
                                    新能源
                                </van-button>                                
                            </div>
                        </div>
                        <!-- 选择车牌号 首个汉字键盘 弹出层 -->
                        <div class="plate_number">
                            <van-popup v-model="show_chinese" position="bottom" :overlay="true"
                                overlay-class="displayNone">
                                <div class="plate_chinese_box">
                                    <!-- 点击对应的汉字，进行输入 -->
                                    <van-button size="small" v-for="(item, index) in ChineseList" :key="item.id"
                                        @click="checkChinese(index)">
                                        {{ item.name }}</van-button>
                                    <div class="close-box" @click.stop="close_keyboard">
                                        <div>╳</div>
                                        <li></li>
                                    </div>
                                </div>
                            </van-popup>
                        </div>
                        <!-- 英文 数字 键盘 -->
                        <div class="allBoard">
                            <van-popup v-model="show_allBoard" position="bottom" :overlay="true"
                                overlay-class="displayNone">
                                <div class="plate_number_box">
                                    <!-- 点击对应的字母或数字，进行输入 -->
                                    <van-button size="small" v-for="(item, index) in English_Number" :key="item.id"
                                        @click="checkEnglish_num(index)">{{ item.name }}</van-button>
                                    <div class="close-box" @click.stop="close_keyboard">
                                        <div>╳</div>
                                        <li></li>
                                    </div>
                                </div>
                            </van-popup>
                        </div>
                    </div>
                </div>
                <div class="imeiInput">
                    <!-- <label class="title" :style="[focus1 ? titleStyle:'']">IMEI号</label> -->
                    <span class="inputText">IMEI号</span>
                    <input placeholder="输入IMEI" type="text" class="input" v-model="filter.imei" @focus="getFocus(0)"
                        @blur="getBlur(0)" @keyup.enter="submitForm()">
                </div>

                <div class="imeiInput">
                    <div class="inputText">验证码</div>
                    <!-- <label class="title" :style="[focus3 ? titleStyle:'']">输入验证码</label> -->
                    <input placeholder="输入验证码" type="text" class="input" v-model="filter.validateCode"
                        @focus="getFocus(2)" @blur="getBlur(2)" @keyup.enter="submitForm()">
                    <img class="verify" :src="'http://chaxun.kcbdgps.com/bdgps/' + valiUrl" style="width:100%;height:100%"
                        @click="valiUrl = valiUrl + '?'" />
                </div>
                <!-- <div class="imeiInput">
                    <img :src="url + valiUrl" style="width:100%;height:100%" @click="valiUrl = valiUrl + '?'" />
                </div> -->
                <!-- <div class="imeiInput"> -->
                <button class="submitBtn" @click="submitForm()">提交</button>
                <!-- </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import preventBack from 'vue-prevent-browser-back';
export default {
    mixins: [preventBack],//阻止返回上一页
    name: 'binding',
    data() {
        return {          
            showKeyboard: true,    //车牌号输入框是否聚焦
            show_chinese: false,     //是否显示汉字键盘
            show_allBoard: false,     //是否显示英文数字键盘
            ChineseList: [
                { name: '京', id: 1 },
                { name: '津', id: 2 },
                { name: '冀', id: 3 },
                { name: '晋', id: 4 },
                { name: '蒙', id: 5 },
                { name: '辽', id: 6 },
                { name: '吉', id: 7 },
                { name: '黑', id: 8 },
                { name: '沪', id: 9 },
                { name: '苏', id: 10 },
                { name: '浙', id: 11 },
                { name: '皖', id: 12 },
                { name: '闽', id: 13 },
                { name: '赣', id: 14 },
                { name: '鲁', id: 15 },
                { name: '豫', id: 16 },
                { name: '鄂', id: 17 },
                { name: '湘', id: 18 },
                { name: '粤', id: 19 },
                { name: '桂', id: 20 },
                { name: '琼', id: 21 },
                { name: '渝', id: 22 },
                { name: '川', id: 23 },
                { name: '贵', id: 24 },
                { name: '云', id: 25 },
                { name: '藏', id: 26 },
                { name: '陕', id: 27 },
                { name: '甘', id: 28 },
                { name: '青', id: 29 },
                { name: '宁', id: 30 },
                { name: '新', id: 31 },
                { name: '←', id: 99 },
            ],
            English_Number: [
                { name: '1', id: 28 },
                { name: '2', id: 29 },
                { name: '3', id: 30 },
                { name: '4', id: 31 },
                { name: '5', id: 32 },
                { name: '6', id: 33 },
                { name: '7', id: 34 },
                { name: '8', id: 35 },
                { name: '9', id: 36 },
                { name: '0', id: 37 },
                { name: 'Q', id: 38 },
                { name: 'W', id: 39 },
                { name: 'E', id: 40 },
                { name: 'R', id: 41 },
                { name: 'T', id: 42 },
                { name: 'Y', id: 43 },
                { name: 'U', id: 44 },
                { name: 'I', id: 45 },
                { name: 'O', id: 46 },
                { name: 'P', id: 47 },
                { name: 'A', id: 48 },
                { name: 'S', id: 49 },
                { name: 'D', id: 50 },
                { name: 'F', id: 51 },
                { name: 'G', id: 52 },
                { name: 'H', id: 53 },
                { name: 'J', id: 54 },
                { name: 'K', id: 55 },
                { name: 'L', id: 56 },
                { name: 'Z', id: 57 },
                { name: 'X', id: 58 },
                { name: 'C', id: 59 },
                { name: 'V', id: 60 },
                { name: 'B', id: 61 },
                { name: 'N', id: 62 },
                { name: 'M', id: 63 },
                { name: '←', id: 99 },
            ],
            plate_number: '',   //车牌号
            first: ' ',
            numArr: [],
            newNumberFlag: false,//false是普通车牌号，true为新能源
            // note: {
            //     backgroundImage: "url(" + require("../assets/images/logo.jpg") + ")",
            //     backgroundRepeat: "no-repeat",
            //     backgroundPosition: "center",
            // },
            focus1: false,
            focus2: false,
            focus3: false,
            titleStyle: {
                bottom: "36px",
                left: "30px",
                fontSize: "12px",
                color: "#54AFF9"
            },
            valiUrl: "api/GPS/GetValidateCode",
            filter: {
                imei: "",
                validateCode: "",
                truck_no: "",
                code: "",
            },
            loading: null,
            // url: "http://192.168.88.80:8011/",
            url:"http://www.bd-gps.com/bdgps/",
            // url:"http://chaxun.kcbdgps.com/bdgps/",
            // url: "http://192.168.88.211:8875/",
        }
    },
    methods: {
       // 唤起键盘
       clickShowKeyboard() {
            // if (!this.first) {
            //     this.show_chinese = true;
            // } else {
            //     this.show_chinese = true;
            //     this.show_allBoard = false;
            // }
            if(this.numArr.length < 1){
                this.show_chinese = true;
                this.show_allBoard = false;
            }else{
                this.show_chinese = false;
                this.show_allBoard = true;
            }
        },
        // 选择车牌号前面的汉字 
        checkChinese(index) {
            // debugger
            // 如果点击删除键，删除第一个格的内容
            if (this.ChineseList[index].id == 99) {
                this.first = ''
            } else {
                // 把选中的字赋值给第一个格，并且切换键盘
                this.first = this.ChineseList[index].name;
                this.show_chinese = false;
                this.show_allBoard = true;
            }
        },
        // 选择车牌号后面的数字和字母 
        checkEnglish_num(index) {
            // 如果点击删除键，删除 numArr 的最后一个值
            if (this.English_Number[index].id == 99) {
                this.numArr.pop()
                // 如果 numArr 里面被删的没有值了，切换键盘
                if (this.numArr.length == 0) {
                    this.show_chinese = true;
                    this.show_allBoard = false;
                }
            } else {
                // 把选中的值 push 到 numArr 内
                this.numArr.push(this.English_Number[index].name)
                // 如果 numArr 中的值超过 7 个（车牌号的最大位数），删除最后一个
                if (this.numArr.length > 7) {
                    this.numArr.pop()
                }else if(this.numArr.length > 1){
                    this.show_chinese = false;
                    this.show_allBoard = true;
                }
            }
        },
        changeNumber() {
            //点击新能源
            this.newNumberFlag = !this.newNumberFlag
            if (this.newNumberFlag && this.numArr.length > 6) {
                this.numArr.pop()
            }
        },
        // 关闭虚拟键盘
        close_keyboard() {
            this.show_chinese = true;
            this.show_allBoard = true;
        },


        // ————————————分割线——————————
      getFocus(val) {
            if (val == 0) {
                this.focus1 = true
            } else if (val == 1) {
                this.focus2 = true
            } else if (val == 2) {
                this.focus3 = true
            }
        },
        getBlur(val) {
            if (val == 0) {
                if (this.filter.imei == "") {
                    this.focus1 = false
                }
            }else if (val == 2) {
                if (this.filter.validateCode == "") {
                    this.focus3 = false
                }
            }
        },
        isVehicleNumber(vehicleNumber) {
            var xreg=/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
            var creg=/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
            if(vehicleNumber.length == 7){
                return creg.test(vehicleNumber);
            } else if(vehicleNumber.length == 8){
                return xreg.test(vehicleNumber);
            } else{
                return false;
            }
        },
        submitForm() {
            var numArrs = this.first+''+(this.numArr).join("")
            // console.log(numArrs,">>>>");
            var reg = /^[0-9]*$/
            var _this = this
            console.log(this.filter.imei.match(reg))
            if (!this.filter.imei.match(reg)){
                this.$dialog({
                    id: 'my-dialog',
                    title: "提示！",
                    content: "请输入正确的imei号后再绑定！",
                    noOkBtn: true,
                    cancelBtnTxt: "我知道了"
                });
                return
            }
            if (this.filter.imei == ""||this.filter.imei.length<10) {
                this.$dialog({
                    id: 'my-dialog',
                    title: "提示！",
                    content: "请输入正确的imei号后再绑定！",
                    noOkBtn: true,
                    cancelBtnTxt: "我知道了"
                });
                return
            }
            if (!this.isVehicleNumber(numArrs)) {
                this.$dialog({
                    id: 'my-dialog',
                    title: "提示！",
                    content: "请输入正确的车牌号后再绑定！",
                    noOkBtn: true,
                    cancelBtnTxt: "我知道了"
                });
                return
            }
            if (this.filter.validateCode.length != 4) {
                this.$dialog({
                    id: 'my-dialog',
                    title: "提示！",
                    content: "请输入正确的验证码！",
                    noOkBtn: true,
                    cancelBtnTxt: "我知道了"
                });
                return
            }

            this.loading = this.$toast.loading('请稍等', {
                coverColor: "rgba(0,0,0,0.5)",
            });
            var filter = {}
            this.filter.truck_no = numArrs
            this.$axios.get(this.url + "api/BindImei/bind_Imei", {
                params: this.filter
            })
            .then(res => {
                this.loading.hide();
                if (res.data.result == "success") {
                    this.$dialog({
                        id: 'my-dialog',
                        title: "提示！",
                        content: res.data.Message,
                        noOkBtn: true,
                        onCancelBtn(event){
                            _this.$router.push({
                                name: 'imeiDetail',
                                params: { detail: "", code: "",imei:_this.filter.imei,}
                            })
                        },
                    });
                } else {
                    this.$dialog({
                        id: 'my-dialog',
                        title: "提示！",
                        content: res.data.Message,
                        noOkBtn: true,
                    });
                    
                }
            })
            .catch((error) => {
                this.loading.hide();
                console.log(error)
            })
        },
        GetRequest() {
            var url = window.location.search
            //获取url中"?"符后的字串  
            var theRequest = new Object();
            if (url.indexOf("?") != -1) {
                let str = url.substr(1);
                let strs = str.split("&");
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
                }
            }
            return theRequest;
        }
    },
    watch: {
        "filter": {
            handler(val) {
                if (val.imei != '') {
                    this.focus1 = true
                }
            }, deep: true
        },
    },
    created() { 
        let dizhi = this.GetRequest()
        if (dizhi.code) {
            this.filter.code = dizhi.code
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;

}

.content .loginBox {
    height: 470px;
    border-radius: 15px;
}

.content .loginBox .header .tabChange {
    display: inline-block;
    line-height: 35px;
    height: 35px;
    margin-right: 15px;
}

.content .loginBox .header .activeChange {
    color: #3370FF;
    position: relative;
}

.content .loginBox .header .activeChange::after {
    content: "";
    position: absolute;
    bottom: 1px;
    width: 100%;
    height: 2px;
    background-color: #3370FF;
    left: 0px;
}

/* .content .loginBox .header .mainTitle {
    text-align: left;
    margin: 0px;
    padding-top: 50px;
    padding-left:30px;
} */
.content .loginBox .header .logoBox {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -50px;
    margin-top: -50px;
    border-radius: 50%;
    background-size: 100px 100px;
    background-position: 0px 0px;
}

.content .loginBox .body {
    height: 390px;
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    margin: 0px 20px;
    margin-top: 30%;
}

.content .loginBox .body .imeiInputs {
    display: flex;
    margin-bottom: -5%;
}

.body .imeiInputs .keyboard-item {
    width: 20%;
    margin-left: 3%;
    margin-right: -3%;
    align-self: center;
}

.content .loginBox .body .imeiInput {
    display: flex;
    height: 36px;
    padding: 60px 11px 0px 10px;
    position: relative;
    border-bottom: 1px solid #E8E8E8;
}

.inputText {
    width: 90px;
}

.verify {
    width: 100px !important;
    height: 50px !important;
    position: absolute;
    right: 10px;
    bottom: 5px;
}

.content .loginBox .body .imeiInput .title {
    position: absolute;
    height: 20px;
    font-size: 14px;
    color: rgba(130, 130, 130, 1);
    bottom: 8px;
    left: 44px;
    transition-duration: 0.4s;
}

.content .loginBox .body .imeiInput .input {
    border-bottom-width: 0;
    border-left-width: 0;
    border-top-width: 0;
    border-right-width: 0;
    width: 100%;
    /* line-height: 20px; */
    margin-bottom: 14px;
}

.content .loginBox .body .submitBtn {
    height: 40px;
    line-height: 40px;
    border: none;
    width: 100%;
    border-radius: 20px;
    background-color: #00AE71;
    color: #ffffff;
    text-align: center;
    margin-top: 30%;
}

.content .loginBox .body .imeiInput .submitBtn:focus {
    border-radius: 5px;
    background-color: #88c7fb;
    transition-duration: 0.4s;
}
</style>

<style>
.nut-dialog-title {
    color: #000000;
    font-weight: bold;
}

.nut-dialog {
    width: 94%;
}

.nut-dialog-content {
    color: #666666;
    font-size: 15px;
}

.nut-dialog-title {
    margin-bottom: 4%;
}

.nut-dialog-footer {
    width: 70%;
    text-align: center;
    margin-left: 50%;
    transform: translate(-50%);
    margin-bottom: 8%;
}

.nut-dialog-footer .nut-dialog-btn {
    background-color: #00AE71;
    font-size: 20px;
    color: #FFFFFF;
    border-radius: 32px
}



.keyboard {
    width: calc(100% - 30px);
    margin: 15px auto;
    position: relative;
}

.keyboard .keyboard-item {
    position: absolute;
    bottom: 120%;
}

.numberCover {
    display: flex;
}

.numberCover .button {
    width: 18%;
    margin-left: 1%;
    border-radius: 3px;
}

.numberCover .button .van-button {
    width: 70%;
    height: 50px;
    background-color: #A3DC60;
    color: #807F0C;
    border: none;
    border-radius: 2px;
    font-size: 12px;
    padding: 0px 10px;
}

.numberCover .van-button--normal {
    padding: 0;
}

.input-box {
    width: 95%;
    height: 52px;
    margin: auto;
    background: rgba(255, 255, 255, 1);
    display: flex;
    justify-content: center;
}

.input-box li {
    flex: 1;
    box-sizing: border-box;
    font-size: 16px;
    display: flex;
    margin: 2px;
    align-items: center;
    justify-content: center;
    color: #187968;
    background-color: #D6F7FA;
    border-radius: 2px;
}

/* .input-box li:last-child {
    border: none;
} */


.class-close-box {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0.5rem;
    top: -40px;
}

.class-close-box-div {
    width: 20px;
    height: 20px;
    font-size: 13;
    line-height: 20px;
    margin: auto;
    text-align: center;
    border: 1px solid #666;
    border-radius: 50%;
}

.class-close-box-li {
    width: 1px;
    height: 0.5rem;
    background: #666;
    margin: auto;
}

.overflow-y {
    overflow-y: inherit;
}

.class-van-button-small {
    min-width: 0;
    border-radius: 5px;
    margin: 5px 2px;
    box-shadow: 5px 5px 5px #aaa;
}

.class-plate-box {
    width: 100%;
    padding: 0.7rem 0.5rem;
    box-sizing: border-box;
    background: #eaf1f9;
    position: relative;
}


.plate_number .plate_chinese_box {
    width: 100%;
    @extend .class-plate-box;
}

.plate_number .van-popup {
    @extend .overflow-y;
}

.plate_number .van-popup--bottom {
    background: #eee;
}


.plate_number .close-box {
    @extend .class-close-box;
}

.plate_number .close-box div {
    @extend .class-close-box-div;
}

.plate_number .close-box li {
    @extend .class-close-box-li;
}

.plate_number .plate_chinese_box .van-button--small {
    height: 64px !important;
    font-size: 20px;
    width: 11.3%;
    @extend .class-van-button-small;
}

.allBoard .van-popup {
    @extend .overflow-y;
}

.allBoard .close-box {
    @extend .class-close-box;
}

.allBoard .close-box div {
    @extend .class-close-box-div;
}

li {
    @extend .class-close-box-li;
}


.allBoard .plate_number_box {
    width: 100%;
    @extend .class-plate-box;
}

.allBoard .plate_number_box .van-button--small {
    height: 64px !important;
    font-size: 20px;
    width: 8.8%;
    @extend .class-van-button-small;
}

.allBoard .plate_number_box .van-button--small:nth-child(1) {
    margin-bottom: 5px;
}

.allBoard .plate_number_box .van-button--small:nth-child(21) {
    margin-left: 5%;
}

.allBoard .plate_number_box .van-button--small:nth-child(30) {
    margin-left: 10%;
}

.allBoard .plate_number_box .van-button--small:last-child {
    width: 13%;
}
</style>



// WEBPACK FOOTER //
// src/components/binding.vue